'use client'

import { useI18N } from '@/context/I18NContext'
import type {
	Language,
	Replacements,
	TranslationKey,
} from '@carbonara/translations'
import { Fragment } from 'react'

export interface I18NTextProps {
	lang?: Language
	text: TranslationKey
	values?: Replacements
}

export const I18NText: React.FC<I18NTextProps> = ({ text, values = {} }) => {
	const { getTranslation } = useI18N()

	const valuesWithDefaults = {
		...values,
		b: values?.b
			? values.b
			: (text: string | string[]) => {
					const values = Array.isArray(text) ? text : [text]
					return <b key={values.join('')}>{values.join('')}</b>
				},
		br: () => (
			<Fragment key="break">
				<br />
				<br />
			</Fragment>
		),
	}

	const translated = getTranslation(text, valuesWithDefaults)

	return <>{translated}</>
}
